import React from 'react'

import VoucherValidateErrorModal from '../voucher-validate-error'
import { VOUCHER_VALIDATE_AFTER_LOGIN } from '../../../constants'

const VoucherValidateErrorAfterLogin = () => {
  return <VoucherValidateErrorModal type={VOUCHER_VALIDATE_AFTER_LOGIN} />
}

export default VoucherValidateErrorAfterLogin
